import BaseService from "../BaseService";
import _ from "lodash";

class CustomerService extends BaseService {
    getByPhone = async (phone) => {
        var data = await this._api.post("/customer/getbyphone", { phone });
        return data;
    };

    list = async (filter) => {
        var data = await this._api.post("/customer/list", filter);
        return data;
    };

    updateStats = async (id) => {
        var data = await this._api.post("/customer/update_stats", { id });
        return data;
    };



    // updatePriceList = async ({ variants }) => {
    //     var data = await this._api.post("/product_variant/update_pricelist", {  variants });
    //     return data;
    // };


    // list = async ({}) => {
    //     var data = await this._api.post("/product_variant/list", { });
    //     return data;
    // };






}
export default CustomerService;
